<div class="tt-o-progress-bar">
  <div class="tt-o-progress-bar__base">
    <div class="tt-o-progress-bar__progress" :style="progressStyles"></div>
  </div>
</div>
